import { createFileRoute } from "@tanstack/react-router";
import FounderPitchDeck from "@/pages/FounderPitchDeck";

export const Route = createFileRoute("/accelerator/pitch-deck/")({
  component: FounderPitchDeck,
});
